import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Grid,
  Stack,
  InputAdornment,
  IconButton,
} from "@mui/material";
import {
  Search as SearchIcon,
  Refresh as RefreshIcon,
  Clear as ClearIcon,
} from "@mui/icons-material";
import { colors, borderRadiusPx, customShadows } from "../../../../../theme";
import {
  CommonInput,
  CommonSelect,
  CommonButton,
} from "../../../../Components/ui";

const MINE_SORT_OPTIONS = [
  { value: "newest", label: "Newest First" },
  { value: "oldest", label: "Oldest First" },
  { value: "highestPrize", label: "Highest Prize Pool" },
  { value: "lowestEntry", label: "Lowest Entry Fee" },
  { value: "capacityHigh", label: "Most Slots (Capacity)" },
  { value: "capacityLow", label: "Fewest Slots (Higher Odds)" },
];

const MineLotteryFilters = ({
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
  onRefresh,
  loading = false,
}) => {
  return (
    <Box
      sx={{
        bgcolor: colors.dashboard.cardBg,
        borderRadius: borderRadiusPx.xl,
        border: `1px solid ${colors.dashboard.cardBorder}`,
        p: { xs: 2, md: 2.5 },
        mb: 4,
        boxShadow: customShadows.cardFlat,
      }}
    >
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* Search Field */}
        <Grid item xs={12} sm={6} md={5}>
          <CommonInput
            placeholder="Search by Mine #ID, Partner name, or Address..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon sx={{ color: colors.slate[400], fontSize: 20 }} />
              </InputAdornment>
            }
            endAdornment={
              searchQuery ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => onSearchChange("")}
                    edge="end"
                    sx={{ color: colors.slate[400] }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ) : null
            }
            fullWidth
            size="small"
          />
        </Grid>

        {/* Sorting & Refresh */}
        <Grid item xs={12} sm={6} md={5}>
          <Stack
            direction="row"
            spacing={1.5}
            justifyContent={{ xs: "flex-start", sm: "flex-end" }}
            alignItems="center"
          >
            <Box sx={{ minWidth: 190, flexGrow: { xs: 1, sm: 0 } }}>
              <CommonSelect
                value={sortBy}
                onChange={(e) => onSortChange(e.target.value)}
                options={MINE_SORT_OPTIONS}
                size="small"
              />
            </Box>
            <CommonButton
              variant="outline"
              size="small"
              onClick={onRefresh}
              disabled={loading}
              sx={{ p: 1, minWidth: 40 }}
            >
              <RefreshIcon
                sx={{
                  fontSize: 18,
                  animation: loading ? "spin 1s linear infinite" : undefined,
                }}
              />
            </CommonButton>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

MineLotteryFilters.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  sortBy: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default MineLotteryFilters;
